/**
 *
 * LoginLayout
 *
 */

import React from "react";
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

// import { FormattedMessage } from 'react-intl';
// import LoginLayout from 'components/LoginLayout'
import messages from "./messages";
import "./styles.scss";

/* eslint-disable react/prefer-stateless-function */
class LoginLayout extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="auth-page">
        <div className="auth-body box">
          {this.props.children}
          {/*<FormattedMessage {...messages.header} />*/}
        </div>
      </div>
    );
  }
}

// LoginLayout.propTypes = {};

export default LoginLayout;
